module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-slot",
    class: {
      'list-slot--disabled': _vm.disabled || _vm.placeholder, 'list-slot--selected': _vm.selected, 'list-slot--no-wrap': _vm.noWrap, 'placeholder list-slot--placeholder': _vm.placeholder, 'list-slot--instant': _vm.instant, 'list-slot--centralised': _vm.centralise, 'list-slot--arrow': !_vm.noArrow
    },
    on: {
      "click": _vm.click
    }
  }, [(!_vm.placeholder) ? _c('div', {
    staticClass: "list-slot__inner"
  }, [_c('span', {
    staticClass: "list-slot__title",
    attrs: {
      "title": _vm.mainText
    }
  }, [_vm._v("\n            " + _vm._s(_vm.mainText) + "\n            "), (_vm.mainDetail) ? _c('span', {
    staticClass: "list-slot__title-detail"
  }, [_vm._v("\n                " + _vm._s(_vm.mainDetail) + "\n            ")]) : _vm._e()]), _vm._v(" "), (_vm.subText != null) ? _c('span', {
    staticClass: "list-slot__subtitle",
    class: {
      'list-slot--with-icon': _vm.shouldShowIcon
    },
    attrs: {
      "title": _vm.subText
    }
  }, [(_vm.instant) ? _c('svg', {
    staticClass: "list-slot__icon",
    attrs: {
      "width": "13",
      "height": "13",
      "title": _vm.subText,
      "viewBox": "0 0 1792 1792"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1333 566q18 20 7 44l-540 1157q-13 25-42 25-4 0-14-2-17-5-25.5-19t-4.5-30l197-808-406 101q-4 1-12 1-18 0-31-11-18-15-13-39l201-825q4-14 16-23t28-9h328q19 0 32 12.5t13 29.5q0 8-5 18l-171 463 396-98q8-2 12-2 19 0 34 15z"
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.subText))])]) : _vm._e(), _vm._v(" "), (_vm.offers && _vm.offers.length && !_vm.disabled) ? _c('div', {
    staticClass: "list-slot__offers"
  }, [_c('div', {
    staticClass: "list-slot-offers-titles"
  }, _vm._l((_vm.offers), function(offer) {
    return _c('div', {
      key: offer.id,
      attrs: {
        "title": offer.name
      }
    }, [_c('svg', {
      staticClass: "list-slot__icon",
      attrs: {
        "width": "10",
        "height": "10",
        "viewBox": "0 0 1792 1792"
      }
    }, [_c('path', {
      attrs: {
        "d": "M576 448q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm1067 576q0 53-37 90l-491 492q-39 37-91 37-53 0-90-37l-715-716q-38-37-64.5-101t-26.5-117v-416q0-52 38-90t90-38h416q53 0 117 26.5t102 64.5l715 714q37 39 37 91z"
      }
    })]), _vm._v(" "), _c('span', [_vm._v("\n                        " + _vm._s(offer.name) + "\n                    ")])])
  }))]) : _vm._e(), _vm._v(" "), (!_vm.disabled && !_vm.noArrow) ? _c('span', {
    staticClass: "list-slot__arrow"
  }, [_c('svg', {
    attrs: {
      "width": "8px",
      "height": "15px"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0 L8 7.5 L0 15 L0 13.5 L6.5 7.5 L0 1.5"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.placeholder) ? [_c('div', {
    staticClass: "list-slot__cover list-slot__cover-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "list-slot__cover list-slot__cover-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "list-slot__cover list-slot__cover-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "list-slot__cover list-slot__cover-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "list-slot__cover list-slot__cover-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "list-slot__cover list-slot__cover-6"
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a14a44be","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/listSlot.vue
// module id = 612
// module chunks = 0